import { UpdateTypeEnum, WupColumnType } from "FoxxyInterfaces";


/**ifleble Zeile, enthält die Id und TableTyp
 * und Liste der ColumnData
  */
export class FlexModelRow {
    //primary
    id : number;
    //Table z.B. Novität oder Platzierung etc.
    TableTyp: string;
    columns: FlexModelColumnData[];
    //foreigns
    children: FlexModelRow[]
}

/**Flexibles Column-Data Model
 * enthält Column und Datatype
 * und Value als any
*/
export class FlexModelColumnData
{
    dataType: WupColumnType;
    columnName: string;
    strValue: any;

    constructor(
        columnName : string,
        dataType: WupColumnType,
        strValue: any
    ) {
        this.dataType = dataType;
        this.columnName = columnName;
        this.strValue = strValue;
    }
}




/**Update Model für GraphQl
 * updatefield -> mutaion
 * queryfields -> was wird zurückgegeben ?
 */
export class UpdateModelData
{
   /**TODO:; hier als oberflächen Typ vorerst */
    dataType: UpdateTypeEnum;

    /**GraphQL OperationName */
    operation: string;
    /**Update Field */
    updateField: string;
    /**Field für Query / Response*/
    queryFields: string[];
    /***Wert */
    anyValue: any;
    /** mögliche Methodenaufruf/Funktion auf GraphqlServer -> add/replace/remove/change */
    method: 'add' | 'replace' | 'remove' | 'change';

    //optional wenn nicht bekannt
    id?: number;

    /**Für Callback z.B .refresh oder recaluculate */
    callBackType?: 'recalculate' ;

    constructor(
        updatefield : string,
        queryfields: string[],
        dataType: UpdateTypeEnum,
        anyValue: any,
        method: 'add' | 'replace' | 'remove' | 'change' = null
    ) {
        this.dataType = dataType;
        this.updateField = updatefield;
        this.anyValue = anyValue;
        this.queryFields = queryfields;
        this.method = method;
    }
}
